/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  useMemo,
} from 'react';

import type {
  StylesConfig,
} from 'react-select';

import {
  useTheme,
} from 'styled-components';

import {
  inputSmall,
} from '../styles/input';
import {
  loadingIndicator,
} from '../styles/loadingIndicator';
import {
  createMultiValueStyle,
} from '../styles/multiValue';
import {
  createMultiValueLabelStyle,
} from '../styles/multiValueLabel';
import {
  createPlaceholderStyle,
} from '../styles/placeholder';
import {
  createSingleValueStyle,
} from '../styles/singleValue';
import {
  createOptionStyle,
} from '../styles/option';

import {
  createContainerStyle,
} from './container';
import {
  menu,
} from './menu';
import {
  createValueContainerStyle,
} from './valueContainer';

export const useFilterStyles = () => {
  const theme = useTheme();

  const styles = useMemo<StylesConfig<any, any, any>>(() => ({
    container: createContainerStyle(theme),
    input: inputSmall,
    loadingIndicator,
    menu,
    multiValue: createMultiValueStyle(theme),
    multiValueLabel: createMultiValueLabelStyle(theme),
    option: createOptionStyle(theme),
    placeholder: createPlaceholderStyle(theme),
    singleValue: createSingleValueStyle(theme),
    valueContainer: createValueContainerStyle(theme),
  }), [
    theme,
  ]);

  return styles;
};
